import React from 'react';

import PaiTextField from 'features/ui/base-components/pai-text-field';
import { useTranslation } from 'react-i18next';
import { BasicActionDialog } from '../../ui/base-dialogs';

interface Props {
  open: boolean;
  tagName: string;
  loading: boolean;
  title: string;

  handleClose(): void;

  handleProceed(): void;

  handleTagNameChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

const CreateSurveyFolderDialog: React.FC<Props> = ({ tagName, handleTagNameChange, title, ...remProps }) => {
  const { t } = useTranslation();
  return (
    <BasicActionDialog
      dialogTitle={title}
      proceedButtonText={t('create')}
      cancelButtonText={t('cancel')}
      maxWidth={'xs'}
      proceedButtonDisabled={tagName.trim() === ''}
      {...remProps}
    >
      <PaiTextField label={t('chooseName')} value={tagName} onChange={handleTagNameChange} />
    </BasicActionDialog>
  );
};

export default CreateSurveyFolderDialog;
